import script from "./navCpn.vue?vue&type=script&setup=true&lang=js"
export * from "./navCpn.vue?vue&type=script&setup=true&lang=js"

import "./navCpn.vue?vue&type=style&index=0&id=aa4bf16e&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa4bf16e"]])

export default __exports__